import styled, { css } from 'styled-components';
import { gridSizes, zIndexses } from 'utils/style';

import StopAddress from 'components/form/StopAddress/container';

const floatingCityStyles = css`
  .floating-city-quote {
    position: absolute;
    color: var(--grey700);
    z-index: ${zIndexses.stopAddressFloatingCityQuote};
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    right: ${gridSizes('XL')};
  }
`;

export default styled(StopAddress)`
  position: relative;
  ${floatingCityStyles};

  .stop-address {
    &__input {
      input {
        padding-right: 4.2rem;
      }
    }
  }
  .icon {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: ${gridSizes('M')};
  }
`;
